// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading__2Koyb"};